/* Read-only bundle presentation. Shopify/the bundle app owns pricing and inventory. */
if (!customElements.get('luniella-bundle-contents')) {
  customElements.define('luniella-bundle-contents', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.list = this.querySelector('.lf-bundle-list');
      this.status = this.querySelector('.lf-bundle-status');
      this.retry = this.querySelector('.lf-bundle-retry');
      this.events = new AbortController();
      this.onVariant = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.load(), 0);
      };
      this.form?.addEventListener('change', this.onVariant, {signal: this.events.signal});
      document.addEventListener('_changeVariant', this.onVariant, {signal: this.events.signal});
      this.retry.addEventListener('click', () => this.load(true), {signal: this.events.signal});
      this.load();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
    }
    async load(force = false) {
      const variant = this.form?.querySelector('[name="id"]')?.value || this.dataset.variant;
      if (!variant || (!force && variant === this.variant)) return;
      this.variant = variant;
      this.request?.abort();
      const request = this.request = new AbortController();
      this.hidden = true;
      this.list.replaceChildren();
      this.retry.hidden = true;
      this.status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        const items = [];
        let after = null;
        let more = true;
        let node;
        for (let page = 0; more && page < 10; page++) {
          const query = `query LuniellaBundle($id: ID!, $after: String) {
            node(id: $id) { ... on ProductVariant {
              id requiresComponents
              components(first: 100, after: $after) {
                nodes { quantity productVariant { id title product { title handle } image { url altText } } }
                pageInfo { hasNextPage endCursor }
              }
            } }
          }`;
          const response = await fetch('/api/2026-10/graphql.json', {
            method: 'POST', credentials: 'same-origin', cache: 'no-store', signal: request.signal,
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({query, variables: {id: 'gid://shopify/ProductVariant/' + variant, after}})
          });
          if (!response.ok) throw new Error('bundle-read');
          const data = await response.json();
          if (data.errors?.length || !data.data?.node?.components) throw new Error('bundle-data');
          node = data.data.node;
          items.push(...node.components.nodes);
          more = node.components.pageInfo.hasNextPage;
          after = node.components.pageInfo.endCursor;
          if (more && !after) throw new Error('bundle-cursor');
        }
        if (more) throw new Error('bundle-incomplete');
        if (this.request !== request || !this.isConnected) return;
        if (!items.length) {
          if (node.requiresComponents) throw new Error('bundle-empty');
          if (this.dataset.editor === 'true') {
            this.hidden = false;
            this.status.textContent = 'لم يُرجع Shopify مكوّنات بندل ثابت لهذا المنتج. اربطي المنتجات من تطبيق البندلز؛ لا تؤثر هذه الخانة على المخزون.';
          }
          return;
        }
        for (const component of items) {
          const variant = component.productVariant;
          if (!variant?.product || !Number.isInteger(component.quantity) || component.quantity < 1) throw new Error('bundle-component');
          const item = document.createElement('li');
          if (this.dataset.images === 'true' && variant.image?.url) {
            const url = new URL(variant.image.url);
            if (url.protocol === 'https:' || url.protocol === 'http:') {
              url.searchParams.set('width', '144');
              const image = document.createElement('img');
              image.src = url.href;
              image.alt = '';
              image.loading = 'lazy';
              image.width = 64;
              image.height = 64;
              item.append(image);
            }
          }
          const copy = document.createElement('div');
          const title = document.createElement('span');
          title.className = 'lf-bundle-name';
          title.textContent = variant.product.title;
          copy.append(title);
          if (variant.title && variant.title !== 'Default Title') {
            const detail = document.createElement('span');
            detail.className = 'lf-bundle-variant';
            detail.textContent = variant.title;
            copy.append(detail);
          }
          item.append(copy);
          const quantity = document.createElement('span');
          quantity.className = 'lf-bundle-quantity';
          quantity.textContent = '× ' + component.quantity;
          quantity.setAttribute('aria-label', 'الكمية ' + component.quantity);
          item.append(quantity);
          this.list.append(item);
        }
        this.hidden = false;
      } catch (error) {
        if (request.signal.aborted || this.request !== request || !this.isConnected) return;
        this.list.replaceChildren();
        this.hidden = false;
        this.status.textContent = 'تعذّر عرض محتويات البوكس الآن. أعيدي المحاولة.';
        this.retry.hidden = false;
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
  });
}
